import i18next from "i18next";
import { useContext } from "react";
import { useQuery } from "react-query";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";
import { Feature, useFeatureFlags } from "context/FeatureFlag";

import { getAIRiskApi } from "../api";
import { AIRiskSession } from "../types";
import { AI_RISK_SESSION_QUERY_KEY } from "./sessionCache";

// Loads the persisted AI risk session. 404 `no_session` is mapped to `null`
// inside the api layer (start view; nothing thrown ⇒ nothing retried).
// `enabled` is flag-gated: with the feature flag off this hook causes ZERO
// network traffic (DoD-4).
export const useAIRiskSession = (projectId: string) => {
  const client = useClient();
  const { isFeatureEnabled } = useFeatureFlags();
  const { displayNotification } = useContext(ControlContext);

  return useQuery<AIRiskSession | null, Error>(
    [AI_RISK_SESSION_QUERY_KEY, projectId],
    () => getAIRiskApi(client).getSession(projectId),
    {
      enabled: isFeatureEnabled(Feature.AIRiskAssessment),
      onError: (error) =>
        displayNotification!(
          i18next.t("risks.ai.errors.sessionLoad"),
          error.message,
          "error"
        ),
    }
  );
};
